export default "__VITE_ASSET__B$nwZFkQ__"